import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import onClickOutside from 'react-onclickoutside';

import {
    display,
    position
} from '../../../../../../commonStyles.js';
import cardCommonStyles from '../cardCommonStyles.js';
import styles from './styles.js';

import ImageCarouselNav from './ImageCarouselNav';
import BackgroundImage from './BackgroundImage';
import StarRating from './StarRating';

import { sendEvent } from '../../../../../../methods';

class MinimalCard extends Component {
    static propTypes = {
        card: PropTypes.object.isRequired,
        cardId: PropTypes.number.isRequired,
        cardPadding: PropTypes.number.isRequired,
        currencySymbol: PropTypes.string.isRequired,
        domain: PropTypes.string.isRequired,
        handleMarkerClick: PropTypes.func.isRequired,
        handleMarkerClose: PropTypes.func.isRequired,
        lang: PropTypes.object.isRequired
    }

    state = {
        activeImageIndex: 0,
        id: `result_${this.props.card.id}`,
        images: this.props.card.images,
        isChangingImage: false
    }

    handleClickOutside = e => {
        const className = e.target.classList.value.split('_')[0];
        const { handleMarkerClick, handleMarkerClose } = this.props;
        if (className === 'overlayView') {
            handleMarkerClick();
        } else {
            handleMarkerClose();
        }
    }

    setActiveImage = (e) => {
        this.setState({ isChangingImage: true });
        const { activeImageIndex, images } = this.state;
        let index = activeImageIndex;
        if (e.target.dataset.direction === 'next') {
            index += 1;
            if (index > (images.length - 1)) {
                index = 0;
            }
        } else if (e.target.dataset.direction === 'previous') {
            index -= 1;
            if (index < 0) {
                index = images.length - 1;
            }
        }
        this.setState({
            activeImageIndex: index
        }, () => {
            setTimeout(() => {
                this.setState({
                    isChangingImage: false
                });
            }, 10);
        });
    }

    sendClickEvent = ({ id }) => {
        sendEvent({
            data: {
                id
            },
            type: 'click'
        });
    }

    render() {
        const {
            setActiveImage,
            sendClickEvent
        } = this;
        const { card, cardPadding, currencySymbol, domain } = this.props;
        const { activeImageIndex, id, images, isChangingImage } = this.state;
        const activeImage = images[activeImageIndex];
        const dataImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAIAAADUVFKvAAAAO0lEQVQIHQEwAM//AVaMo+ny9ub19/X5/P39/QGVmJERDg7y9ffe4eXy9fgBh2I0Gg8EAwQFCwsL8/b6AlYbs3x20IQAAAAASUVORK5CYII=';
        const isMobile = window.matchMedia('(max-width: 743px)').matches;
        return (
            <div
                id={id}
                className="card"
                style={{
                    width: '250px',
                    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.39)'
                }}
            >
                <div
                    className={css(styles.container_fullWidth)}
                    style={{
                        paddingTop: `${cardPadding}%`,
                        backgroundImage: `url('${dataImage}')`,
                        backgroundSize: '100% 100%'
                    }}
                >
                    <div className={css(styles.children)}>
                        <div className={css(styles.fullWidth_fullHeight)}>
                            <div className={css(position.relative, styles.fullWidth_fullHeight)}>
                                <BackgroundImage
                                    image={activeImage}
                                    isUpdating={isChangingImage}
                                />
                            </div>
                        </div>
                        <ImageCarouselNav
                            card={card}
                            domain={domain}
                            sendClickEvent={sendClickEvent}
                            setActiveImage={setActiveImage}
                        />
                    </div>
                </div>
                <div
                    style={{
                        padding: '10px',
                        backgroundColor: '#FFF',
                        height: '84px'
                    }}
                >
                    <div
                        style={{
                            marginTop: '8px'
                        }}
                    >
                        <div className={css(styles.twoLineTitle)}>
                            <a
                                className={css(styles.linkContainer)}
                                href={`/${domain}${card.url}`}
                                rel="noopener noreferrer"
                                {...(!isMobile ? { target: '_blank' } : {})}
                            >
                                <div className={css(styles.roomInfoContainer)}>
                                    <span
                                        className={css(
                                            styles.cardText,
                                            cardCommonStyles.size_micro,
                                            cardCommonStyles.weight_bold,
                                            display.inline
                                        )}
                                    >
                                        {card.title}
                                    </span>
                                    <br />
                                    <span
                                        className={css(
                                            styles.cardText,
                                            cardCommonStyles.size_micro,
                                            cardCommonStyles.weight_light,
                                            display.inline
                                        )}
                                    >{
                                    card.max_capacity > 0 ?
                                    card.max_capacity_string : null
                                    }</span>
                                </div>
                                <div
                                    className={css(styles.roomInfoContainer)}
                                    style={{ textAlign: 'right' }}
                                >
                                    <span
                                        className={css(
                                            cardCommonStyles.text,
                                            cardCommonStyles.size_micro,
                                            cardCommonStyles.weight_bold,
                                            display.inline
                                        )}
                                    >
                                        <span dangerouslySetInnerHTML={{ __html: currencySymbol }} />{
                                            Number(card.listing_hourly_rate) < 100 ? Number(card.listing_hourly_rate).toFixed(2) : Number(card.listing_hourly_rate)
                                        }
                                    </span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <StarRating
                        reviewCount={card.review_count}
                        reviewCountString={card.review_count_string}
                        reviewScore={Number(card.review_score)}
                    />
                </div>
            </div>
        );
    }
}

export default onClickOutside(MinimalCard);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/MinimalCard.jsx